import React, { useEffect, useState } from 'react'
import { Clipboard2CheckFill } from 'react-bootstrap-icons'
import DatePicker from '../../../../../components/ui/calendar/date_picket/DatePicker'
import Questionnaire from '../../../../../libs/api/services/Questionnaire'
import QuestionnaireAssignment from '../../../../../libs/api/services/QuestionnaireAssignment'

export default function FormAssignmentSelection({ title, description, navigation, errors, setValue, values }) {

  const [questionnaires, setQuestionnaires] = useState([])
  const [questionnaire, setQuestionnaire] = useState()
  const [completedDate, setCompletedDate] = useState(values?.completedDate)

  useEffect(() => {
    title('Forms')
    description('Please select the form you would like to complete')
    navigation([
      { text: '', type: '', action: async () => { } },
    ])

    if (Object.keys(values).includes('questionnaire'))
      setQuestionnaire(values.questionnaire)
    if (Object.keys(values).includes('completedDate'))
      setCompletedDate(values.completedDate)

    load();
  }, [])

  useEffect(() => {
    if (questionnaire)
      navigation([
        {
          text: 'Next', type: 'Done', action: async () => {
            QuestionnaireAssignment
              .AssignQuestionnaire(values.questionnaire.id, values.user.userProfile.id, {
                assignedDate: values.scheduleDateTime,
                completedDate: values.completedDate,
                questionnaire: {
                  name: ''
                },
                Responses: []
              }).then((r) => {
                window.location = '/Dashboard/Patient/' + values.user.id + '/Form/' + values.questionnaire.id + '/' + r.id
              });
          }
        },
      ])
  }, [questionnaire, values.completedDate])

  const load = () => {
    Questionnaire
      .ListQuestionnairesByType('Form', true)
      .then((r) => {
        setQuestionnaires(r)
      })
  }

  const _handleSetQuestionnaire = (q) => {
    setValue({ questionnaire: q })
    setQuestionnaire(q)
  }

  return (
    <div className='h-100 d-flex flex-column bg-primary-container rounded m-3' style={{ overflow: 'auto' }}>
      <div className='mb-3 p-2 bg-secondary-container rounded'>
        <div className='mb-2'><b>Optional completed date</b></div>
        <DatePicker
          defaultValue={completedDate}
          onChange={(d) => {
            setCompletedDate(d)
            setValue({ completedDate: d })
          }}
        />
      </div>

      {
        questionnaires.map((q) =>
          <div
            key={q.id}
            style={{ cursor: 'pointer' }}
            className={'m-1 p-1 text-start  '.concat(questionnaire && questionnaire.id === q.id ? ' active ' : '')}
            onClick={(e) => _handleSetQuestionnaire(q)}
          >
            <Clipboard2CheckFill className='me-2' size={20} />{q.name}</div>
        )
      }

    </div>
  )
}
